import { render, staticRenderFns } from "./topbarNotificationsList.vue?vue&type=template&id=fc9d8df8&"
import script from "./topbarNotificationsList.vue?vue&type=script&lang=js&"
export * from "./topbarNotificationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports